var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTurnRibbon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 440 101",
    style: {
      enableBackground: "new 0 0 440 101"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2A3648;}\n\t.st1{fill:none;stroke:url(#SVGID_1_);}\n\t.st2{fill:none;stroke:url(#SVGID_00000061472026739899509590000005453398111553223089_);}\n\t.st3{fill:#BB6D2A;}\n\t.st4{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h440l-34,50.5l34,50.5H0l35-50.5L0,0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.4581,
    y1: 72.3394,
    x2: 434.4691,
    y2: 11.7868,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#34425B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#617394"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1,0.5h438.1l-33.5,49.7l-0.2,0.3l0.2,0.3l33.5,49.7H1l34.5-49.7l0.2-0.3l-0.2-0.3L1,0.5z"
  }))), /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,10h388l-24,39l24,42H28l22-42L28,10z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045602642309303841690000007540985120889277833_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.0998,
    y1: 74.3694,
    x2: 418.3488,
    y2: 9.098,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BB6D2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CC9769"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000045602642309303841690000007540985120889277833_)"
    },
    d: "M28.9,10.5h386.2l-23.5,38.2 l-0.2,0.3l0.1,0.3l23.6,41.3H28.8l21.6-41.3l0.1-0.2l-0.1-0.2L28.9,10.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnRibbon);
export default __webpack_public_path__ + "static/media/turn-ribbon.c320be17fee1be25923171849cc95071.svg";
export { ForwardRef as ReactComponent };